import { render } from "./CalendarField.vue?vue&type=template&id=1b4e6fbe"
import script from "./CalendarField.vue?vue&type=script&lang=js"
export * from "./CalendarField.vue?vue&type=script&lang=js"

import "./CalendarField.vue?vue&type=style&index=0&id=1b4e6fbe&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__